module.exports = __webpack_public_path__ + "static/img/20210717174047.bc1343c3.jpg";